import Component from "@glimmer/component";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { stringable } from "glesys-controlpanel/utils/prop-types";
import { bool, func } from "prop-types";
import { modifier } from "ember-modifier";

@forbidExtraArgs
export default class AtomDeleteOption extends Component {
  @arg(stringable.isRequired) key;
  @arg(stringable) label;
  @arg(bool) selected = false;
  @arg(func.isRequired) onChange;

  handleDefault = modifier((element) => element.dispatchEvent(new Event("change", { bubbles: true })));
}
